import { gql } from "@apollo/client";

const MODIFICAR_VISITA = gql`
mutation ModificarVisita($idVisita: Int!) {
    modificacionVisita(idVisita: $idVisita)
}`;

export default MODIFICAR_VISITA;